'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconUpload, iconUploadTag } from '@ni/nimble-components/dist/esm/icons/upload';
import { wrap } from '../../utilities/react-wrapper';

export type { IconUpload };
export { iconUploadTag };
export const NimbleIconUpload = wrap(IconUpload);